import { z } from "zod";
export const SemanticVersionSchema = z
    .string()
    .regex(/^(?:0|[1-9]\d*)\.(?:0|[1-9]\d*)\.(?:0|[1-9]\d*)$/, "Expected semantic version MAJOR.MINOR.PATCH");
export const HttpContractVersionSchema = z
    .string()
    .regex(/^v[1-9]\d*$/, "Expected an HTTP contract major such as v1");
export const ContractVersionMetadataSchema = z.object({
    family: z.literal("payday"),
    packageVersion: SemanticVersionSchema,
    httpVersion: HttpContractVersionSchema,
});
export const CURRENT_CONTRACT_VERSION = Object.freeze({
    family: "payday",
    packageVersion: "0.1.0",
    httpVersion: "v1",
});
//# sourceMappingURL=contract-version.js.map